module.exports = __webpack_public_path__ + "img/1532739130.dee67ee9.jpg";